module.exports = __webpack_public_path__ + "static/media/how-to-desk.068af429.png";